(function($){

    $('[data-sp-bleeding-angle]').each(function() {

        var angle = $(this),
            angleInner = angle.find('> span').first();

        if (angleInner.length < 1)
        {
            angleInner = $('<span></span>');
            angle.prepend(angleInner);
        }

        var update = function() {
            angleInner.css('transform', 'skewX(' + (Math.atan2(angle.outerWidth(), angle.outerHeight()) * 180 / Math.PI) + 'deg)');
        };

        $(window).resize(function() {
            update();
        });

        update();

        setTimeout(function() {
            update();
        }, 1000);
    });

    $('[data-sp-bleeding-background]').each(function() {

        var background = $(this),
            position = background.data('sp-bleeding-background');

        var update = function() {

            var offset = background.offset();

            if ('right' === position)
            {
                background.css('right', 'auto');
                background.width($(window).outerWidth() - offset.left);
            }
            else
            {
                background.css('left', 'auto');
                background.width(offset.left + background.outerWidth());
            }
        };

        $(window).resize(function() {
            update();
        });

        update();

        setTimeout(function() {
            update();
        }, 1000);
    });

    /*$('.bleeding-container').each(function() {

        var container = $(this),
            direction = '';

        if (container.hasClass('bleeding-container-top'))
        {
            direction = 'top';
        }
        else if (container.hasClass('bleeding-container-right'))
        {
            direction = 'right';
        }
        else if (container.hasClass('bleeding-container-bottom'))
        {
            direction = 'bottom';
        }
        else if (container.hasClass('bleeding-container-left'))
        {
            direction = 'left';
        }

        var update = function()
        {
            var rootOffset = container.closest('.sp-slider-item').offset().left;
            console.log('rootOffset', rootOffset);

            if ('left' === direction)
            {
                console.log('left', (container.offset().left + rootOffset) * -1);
                container.find('.bleeding-container-background').css('left', (container.offset().left + rootOffset) * -1);
            }
            else if ('right' === direction)
            {
                var test = $(window).outerWidth() - ((container.offset().left + rootOffset) + container.outerWidth());
                console.log('right', test * -1);
                container.find('.bleeding-container-background').css('right', test * -1);
            }
        }

        $(window).resize(function() {
            update();
        });

        update();

        setTimeout(function() {
            update();
        }, 100);
    });*/

})(jQuery);
